import dayjs from "dayjs";
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

const getLastSixMonth = (month, year, t) => {
  const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  const currentYear = [...months]
    .slice(Math.max(month - 5, 0), month + 1)
    .map((item) => {
      const month = (item + 1 + 100).toString().substring(1, 3);
      return {
        value: `${year}-${month}`,
        label: `${t(`month.${month}`)}  ${year}`,
      };
    })
    .reverse();
  const countMonth = currentYear.length;
  if (countMonth < 6) {
    const lastYear = [...months]
      .slice(countMonth - 6)
      .map((item) => {
        const month = (item + 1 + 100).toString().substring(1, 3);
        return {
          value: `${year - 1}-${month}`,
          label: `${t(`month.${month}`)}  ${year - 1}`,
        };
      })
      .reverse();
    return [...currentYear, ...lastYear];
  }
  return [...currentYear];
};

const getLastSixWeeks = (month, year) => {
  const apiDateFormat = "YYYY-MM-DD"
  const labelDateFormat = 'MM/DD/YY';
  // console.log('nowLocalTime', dayjs())
  //use isoWeek(1) to set first day of a week to Monday
  const lastSixWeeks = [1, 2, 3, 4, 5, 6].map((i, index) => {
    return {
      value: dayjs().isoWeekday(1 - index * 7).format(apiDateFormat) + '~' + dayjs().isoWeekday(7 - index * 7).format(apiDateFormat),
      label: dayjs().isoWeekday(1 - index * 7).format(labelDateFormat) + ' - ' + dayjs().isoWeekday(7 - index * 7).format(labelDateFormat),
    };
  });
  // console.log('lastSixWeeks', lastSixWeeks)
  return [...lastSixWeeks];
};

export { getLastSixMonth, getLastSixWeeks };

